export default "__VITE_ASSET__B$cp9CrT__"